import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import useSWR from 'swr';
import CoinImg from '../../assets/images/img_coin.png';
import { AuthOnboardingLayout } from '../../components/login-v2/AuthShell';
import AuthPrimaryButton from '../../components/login-v2/AuthPrimaryButton';
import { AuthContext } from '../../context/AuthContext';
import { clearSignupOnboarding, getSignupNickname, isSignupOnboarding } from './signupStorage';

function hasStoredAuth() {
  return Boolean(localStorage.getItem('accessToken') && localStorage.getItem('refreshToken'));
}

export default function LoginV2CompletePage() {
  const navigate = useNavigate();
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  const [nickname, setNickname] = useState(getSignupNickname());

  const { data: authProfile } = useSWR(
    accessToken && [`${API_SERVER_DOMAIN}/auth/user/check`, accessToken],
    fetchWithToken,
  );

  useEffect(() => {
    if (!accessToken && !hasStoredAuth()) {
      navigate('/login', { replace: true });
      return;
    }
    if (accessToken && !isSignupOnboarding()) {
      navigate('/playground', { replace: true });
    }
  }, [accessToken, navigate]);

  useEffect(() => {
    const fromProfile = authProfile?.userInfo?.nickName || authProfile?.userInfo?.nickname;
    if (fromProfile) setNickname(fromProfile);
  }, [authProfile]);

  const start = () => {
    clearSignupOnboarding();
    navigate('/playground', { replace: true });
  };

  const displayName = nickname || '야옹';

  return (
    <AuthOnboardingLayout
      actions={<AuthPrimaryButton onClick={start}>시작하기</AuthPrimaryButton>}
    >
      <div className="flex min-h-full flex-col px-[10px] pt-14">
        <div>
          <h1 className="font-['Pretendard'] text-[22px] font-bold leading-[1.32] text-black">
            {displayName}님 환영해요 !
          </h1>
          <p className="mt-2 font-['Pretendard'] text-[16px] leading-[1.4] text-gray04">
            벌써 <span className="text-primary-purple-01">포인트가 쌓여있어요.</span>
            <br />
            매일 오기만 하세요!
          </p>
        </div>

        <div className="flex flex-1 items-center justify-center py-10">
          <img src={CoinImg} alt="" role="presentation" className="h-[157px] w-[170px] object-contain" />
        </div>
      </div>
    </AuthOnboardingLayout>
  );
}
